import React, {Component} from 'react'
import moment from 'moment'
import DateRangePicker from 'react-bootstrap-daterangepicker'


class DateAndTimePicker extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
		//? This element was floating away when scrolled down the screen and in a modal.
	}

	apply = (event, picker) => {
		var dates = {
			start: picker.startDate.unix(),
			end: picker.endDate.unix(),
		}
		let endHour = picker.endDate.hour()
		let endMinute = picker.endDate.minute()
		dates.end = picker.startDate.hour(endHour).minute(endMinute).unix()
		// Change the end date to the same as start date, as this componenet is meant to pick a single date and time range
		
		this.props.onChange(this.props.name, dates)
	}

	determineValue = () => {
		if(this.props.value) {
			let str = ``
			str += moment.unix(this.props.value.start).format(`M/DD LT - `)
			str += moment.unix(this.props.value.end).format(`LT`)
			return str
		}
		return ''
	}

	render() {
		return (
			<DateRangePicker
				onApply={this.apply}
				onShow={() => {
					if (this.props.fixed) {
						let el = document.querySelectorAll(".daterangepicker")
						_.forEach(el, (v) => {
							v.style.position = "fixed"
						})
					}
				}}
				initialSettings={{
					maxSpan: {
						days: 1,
					},
					timePicker: true,
					timePickerIncrement: 15,
					autoUpdateInput: false,
					//startDate: moment().startOf("hour").toDate(),
					//endDate: moment().startOf("hour").add(1, "hour").toDate(),
					locale: {
						format: "M/DD hh:mm A",
					},
					//opens: "left",
					//parentEl: "#foobartest", // not working atm
				}}>
				<input type="text" className="form__input" value={this.determineValue()} />
			</DateRangePicker>
		)
	}
}

export default DateAndTimePicker
